// extracted by mini-css-extract-plugin
export default {"warningCard":"WarningCard_warningCard__M1A4U","title":"WarningCard_title__xafqf","description":"WarningCard_description__6DCt8"};